import * as c from './types';

import createReducer from '../../reducers/utils/createReducer';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  shiftIndicators: [],
  considerIdleShift: null,
  isIdleShitsFlagLoading: false,
  isUpdateInProgress: false
};

export default createReducer(initialState, {
  [c.POST_SHIFT_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.POST_SHIFT_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false
  }),
  [c.POST_SHIFT_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.GET_SHIFT_INDICATORS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_SHIFT_INDICATORS_SUCCESS]: (state, { payload }) => ({
    ...state,
    shiftIndicators: payload,
    isLoading: false
  }),
  [c.GET_SHIFT_INDICATORS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.POST_SHIFT_IS_CONSIDERED_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.POST_SHIFT_IS_CONSIDERED_SUCCESS]: (state) => ({
    ...state,
    error: null,
    isLoading: false
  }),
  [c.POST_SHIFT_IS_CONSIDERED_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.GET_IDLE_SHIFTS_FLAG_REQUEST]: (state) => ({
    ...state,
    error: null,
    isIdleShitsFlagLoading: true
  }),
  [c.GET_IDLE_SHIFTS_FLAG_SUCCESS]: (state, { payload }) => ({
    ...state,
    considerIdleShift: payload,
    isIdleShitsFlagLoading: false
  }),
  [c.GET_IDLE_SHIFTS_FLAG_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isIdleShitsFlagLoading: false
  }),
  [c.PUT_IDLE_SHIFTS_FLAG_REQUEST]: (state) => ({
    ...state,
    error: null,
    isUpdateInProgress: true
  }),
  [c.PUT_IDLE_SHIFTS_FLAG_SUCCESS]: (state, { payload }) => ({
    ...state,
    considerIdleShift: payload,
    isUpdateInProgress: false
  }),
  [c.PUT_IDLE_SHIFTS_FLAG_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isUpdateInProgress: false
  })
});
